import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { skills } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function SkillsSection() {
  return <section className="bg-crudo px-5 py-14 text-noche sm:px-8 lg:py-18" data-id="element-160" data-mp="343x6jgfqupb4">
      <div className="mx-auto max-w-6xl" data-id="element-161" data-mp="346t77ciz7s39">
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.4,
        ease: EASE
      }} className="font-display text-2xl font-black uppercase leading-tight sm:text-3xl lg:text-4xl" data-id="element-162" data-mp="384z843x4vdg9">
          Aprendé el proceso completo
        </motion.h2>

        {/* Sequential journey — the arrows carry the order */}
        <ol className="mt-8 flex flex-col gap-2 lg:flex-row lg:items-stretch lg:gap-0" data-id="element-163" data-mp="2pdg90868cjji">
          {skills.map((skill, index) => <motion.li key={skill.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: Math.min(index, 4) * 0.05,
          ease: EASE
        }} className="flex items-center gap-2 lg:flex-1 lg:flex-col lg:items-stretch lg:gap-0" data-id="element-164" data-mp="4osfqtk652ms" data-mpi={index}>
              <div className="flex flex-1 items-start gap-3 rounded-xl border border-aluminio bg-white p-4 lg:h-full lg:flex-col lg:gap-0 lg:p-5" data-id="element-165" data-mp="3a0y8jxzof3bx">
                <span className="text-xl leading-none" aria-hidden="true" data-id="element-166" data-mp="3158n5oy8a8yj">
                  {skill.icon}
                </span>
                <div className="lg:mt-2" data-id="element-167" data-mp="2w7gli37s78h5">
                  <h3 className="font-display text-sm font-extrabold uppercase tracking-wide sm:text-base" data-id="element-168" data-mp="2r8m5ta542019">
                    {skill.title}
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-noche/60" data-id="element-169" data-mp="2mb3r134ewqlc">
                    {skill.text}
                  </p>
                </div>
              </div>

              {index < skills.length - 1 && <ChevronRightIcon className="h-5 w-5 shrink-0 rotate-90 text-electrico lg:mx-1 lg:self-center lg:rotate-0" aria-hidden="true" data-id="element-170" data-mp="2cldl9ipwwicm" />}
            </motion.li>)}
        </ol>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4,
        ease: EASE
      }} className="mt-9 text-center font-display text-base font-black uppercase leading-tight text-electrico sm:text-xl" data-id="element-171" data-mp="23l8pk5u2z8ea">
          De los fundamentos a un trabajo terminado.
        </motion.p>
      </div>
    </section>;
}